import { render, staticRenderFns } from "./ModalChangeFeature.vue?vue&type=template&id=72422014&scoped=true"
import script from "./ModalChangeFeature.vue?vue&type=script&lang=js"
export * from "./ModalChangeFeature.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeFeature.vue?vue&type=style&index=0&id=72422014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72422014",
  null
  
)

export default component.exports